<template>

    <Head>
        <title>{{ title }}</title>
        <meta name="description" :content="description">
    </Head>
    <Header :agency="agency" :bg_img="bg_img"></Header>
    <Layout>
        <div class="content-blocks">
            <div class="landing-reprise-depot">
                <!-- Première section - Hero -->
                <section class="hero-section">
                    <div class="container">
                        <div class="hero-content">
                            <div class="hero-text">
                                <h1 class="hero-title">
                                    <span class="title-line">VENDEZ VOTRE VOITURE<br>RAPIDEMENT ET SEREINEMENT</span>
                                    <span class="title-line">AVEC
                                        <img src="/img/logo-ewigo_best.png" alt="Ewigo" class="ewigo-logo">
                                    </span>
                                </h1>
                                <button class="cta-button" @click="openEstimationModal">
                                    <span>Je mets en vente</span>
                                    <div class="arrow-circle">
                                        <img src="/img/landing-page/arrow-circle-right.svg" alt="Arrow" />
                                    </div>
                                </button>
                            </div>
                            <div class="hero-image">
                                <img src="/img/landing-page/Opel.png" alt="Opel" class="car-image">
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Deuxième section - Options de vente -->
                <section class="options-section">
                    <div class="container">
                        <div class="options-header">
                            <h2 class="options-title">DEUX OPTIONS POUR VENDRE SA VOITURE AVEC EWIGO</h2>
                            <p class="options-subtitle">Vous êtes unique, votre projet auto également.</p>
                        </div>

                        <div class="options-cards">
                            <div class="option-card">
                                <div class="card-header">
                                    <h3>REPRISE CASH</h3>
                                </div>
                                <div class="card-content">
                                    <ul>
                                        <li><strong>Rachat instantané</strong></li>
                                        <li>Estimation en direct et gratuite</li>
                                        <li>Versement des fonds sous 48 heures</li>
                                        <li>Toutes vos démarches simplifiées</li>
                                    </ul>
                                    <button class="card-button" @click="openEstimationModal">
                                        <span>Je fais reprendre</span>
                                        <div class="arrow-circle">
                                            <img src="/img/landing-page/arrow-circle-right.svg" alt="Arrow" />
                                        </div>
                                    </button>
                                </div>
                            </div>

                            <div class="option-card">
                                <div class="card-header">
                                    <h3>MISE EN VENTE PROFESSIONNELLE</h3>
                                </div>
                                <div class="card-content">
                                    <ul>
                                        <li><strong>Gagnez plus </strong>qu'une reprise en
                                            concession classique</li>
                                        <li>Estimation en direct et gratuite</li>
                                        <li>Toutes vos démarches simplifiées</li>
                                        <li>Véhicules de -15 ans et -150.000 kms</li>
                                    </ul>
                                    <button class="card-button" @click="openEstimationModal">
                                        <span>Je mets en vente</span>
                                        <div class="arrow-circle">
                                            <img src="/img/landing-page/arrow-circle-right.svg" alt="Arrow" />
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Troisième section - Pourquoi vendre avec Ewigo -->
                <section class="why-ewigo-section">
                    <div class="container">
                        <div class="why-ewigo-header">
                            <h2 class="why-ewigo-title">POURQUOI VENDRE SA VOITURE AVEC EWIGO ?</h2>
                            <p class="why-ewigo-subtitle">Avec Ewigo, vous faites le choix d'un service reconnu et
                                apprécié partout en France.</p>
                        </div>

                        <div class="benefits-grid">
                            <div class="benefits-column">
                                <div class="benefit-item">
                                    <div class="benefit-icon">
                                        <img src="/img/landing-page/euros.svg" alt="Euros" />
                                    </div>
                                    <div class="benefit-text">Gagner plus qu'une reprise en concession classique</div>
                                </div>
                                <div class="benefit-item">
                                    <div class="benefit-icon">
                                        <img src="/img/landing-page/lock.svg" alt="Sécurité" />
                                    </div>
                                    <div class="benefit-text">Sécuriser sa transaction via un compte séquestre</div>
                                </div>
                                <div class="benefit-item">
                                    <div class="benefit-icon">
                                        <img src="/img/landing-page/check_circle.svg" alt="Certification" />
                                    </div>
                                    <div class="benefit-text">Certifier sa voiture fiable ou remboursé</div>
                                </div>
                            </div>

                            <div class="benefits-column">
                                <div class="benefit-item">
                                    <div class="benefit-icon">
                                        <img src="/img/landing-page/stopwatch.svg" alt="Chronomètre" />
                                    </div>
                                    <div class="benefit-text">1 vente toutes les 4 mins dans le réseau Ewigo</div>
                                </div>
                                <div class="benefit-item">
                                    <div class="benefit-icon">
                                        <img src="/img/landing-page/directions_car.svg" alt="Voiture" />
                                    </div>
                                    <div class="benefit-text">Livrer sa voiture partout en France</div>
                                </div>
                                <div class="benefit-item">
                                    <div class="benefit-icon">
                                        <img src="/img/landing-page/pen_tool.svg" alt="Administratif" />
                                    </div>
                                    <div class="benefit-text">Toutes vos démarches simplifiées</div>
                                </div>
                            </div>
                        </div>

                        <div class="why-ewigo-cta">
                            <button class="cta-button" @click="openEstimationModal">
                                <span>Je mets en vente</span>
                                <div class="arrow-circle">
                                    <img src="/img/landing-page/arrow-circle-right.svg" alt="Arrow" />
                                </div>
                            </button>
                        </div>
                    </div>
                </section>

                <!-- Quatrième section - Réseaux sociaux, récompenses et note Google -->
                <section class="social-awards-section">
                    <div class="container">
                        <div class="social-awards-content">
                            <div class="left-content">
                                <div class="car-image-container">
                                    <img src="/img/landing-page/Mercedes.png" alt="Mercedes" class="final-car-image">
                                </div>
                            </div>

                            <div class="right-content">
                                <div class="social-media">
                                    <h3>Rendez-vous sur :</h3>
                                    <div class="social-icons">
                                        <a href="https://www.facebook.com/AgenceAutomobile/" class="social-icon facebook">
                                            <img src="/img/landing-page/FB_logo.png" alt="Facebook" />
                                        </a>
                                        <a href="https://www.instagram.com/ewigofrance/" class="social-icon instagram">
                                            <img src="/img/landing-page/Insta_logo.png" alt="Instagram" />
                                        </a>
                                        <a href="https://www.youtube.com/channel/UCfQScblYW971yS5qK_OE0CA" class="social-icon youtube">
                                            <img src="/img/landing-page/YT_logo.png" alt="YouTube" />
                                        </a>
                                        <a href="https://www.linkedin.com/company/ewigo-france/" class="social-icon linkedin">
                                            <img src="/img/landing-page/Linkedin_logo.png" alt="LinkedIn" />
                                        </a>
                                    </div>
                                </div>

                                <div class="awards-google-container">
                                    <div class="awards-section">
                                        <div class="awards-badges">
                                            <img src="https://www.ewigo.com/wp-content/uploads/2026/04/MCDMA-2026-4-annee.png"
                                                alt="Meilleure chaîne de magasins de l'année" class="awards-image">
                                        </div>
                                    </div>

                                    <div class="google-rating">
                                        <img src="https://www.ewigo.com/wp-content/uploads/2026/04/Google-2026-noir-sans-fond.png" alt="Avis Google 2026"
                                            class="google-rating-image">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </Layout>
    <Footer :agency="agency" :bg_img="bg_img" :hide-carte-grise="true"></Footer>

    <!-- Modal d'estimation -->
    <EstimationModal :is-open="showEstimationModal" :agency="agency" :agency-france-id="agency_france"
        :initial-registration="registration" :initial-mileage="mileage" :reference="reference" :utm-id="utm_id"
        :captcha="captcha" @close="closeEstimationModal" @success="onEstimationSuccess" />
</template>

<script>
import _, { throttle } from 'lodash';
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import { Head } from '@inertiajs/inertia-vue3'
import Header from "@/Pages/Partials/Header"
import Layout from './Ads/Layout'
import Footer from "@/Pages/Partials/Footer"
import EstimationModal from "@/Pages/Partials/EstimationModal"

export default {
    components: {
        Head,
        Header,
        Layout,
        Footer,
        Carousel,
        Slide,
        Pagination,
        Navigation,
        EstimationModal,
    },
    props: {
        agency: Object,
        agency_france: String,
        registration: String,
        mileage: String,
        title: String,
        description: String,
        reference: String,
        utm_id: String,
        captcha: String,
        bg_img: String,
    },
    data() {
        return {
            reviews: [],
            showFakeReviews: false,
            showEstimationModal: false,
        }
    },
    methods: {
        getReviews() {
            axios.get(`${this.$page.props.ewigoExtranetUrl}/api/get/reviews/${this.agency.id_ewigo}`)
                .then((response) => {
                    this.showFakeReviews = false;
                    this.reviews = response.data.data;
                })
                .catch((error) => {
                    if (error) {
                        this.showFakeReviews = true;
                        this.reviews = [];
                        // refresh
                    }
                })
        },
        openEstimationModal() {
            this.showEstimationModal = true;
        },
        closeEstimationModal() {
            this.showEstimationModal = false;
        },
        onEstimationSuccess(data) {
            console.log('Estimation envoyée avec succès:', data);
            // Optionnel: afficher un message de succès ou rediriger
        },
    },
    created() {
        this.getReviews();
    },
}
</script>

<style lang="scss" scoped>
// Masquer le "Skip to content" et corriger les styles du header
:global(.skip-link) {
    display: none !important;
}

:global(.site-header) {
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
}

:global(.site-header .container) {
    border: none !important;
    margin: 0 !important;
    padding: 1rem !important;
}

.landing-reprise-depot {
    .hero-section {
        background: #1e324e;
        min-height: calc(110vh - 80px); // Ajuster pour laisser de l'espace pour le header
        display: flex;
        align-items: center;
        padding: 2rem 0;
        margin-top: 0; // S'assurer qu'il n'y a pas de marge qui cache le header
    }

    .container {
        max-width: 100%;
        margin: 0 50px;
        margin-right: 0;
        padding: 0 1rem;
        padding-right: 0;
    }

    .ewigo-logo {
        height: 0.9em; // prend la taille de la police courante
        vertical-align: middle; // centré verticalement avec le texte
        margin-left: 0.2em; // petit espacement avec le texte AVEC
    }

    .hero-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 3rem;
        align-items: center;
    }

    .hero-text {
        color: white !important;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .logo-container {
        margin-bottom: 2rem;

        .ewigo-logo {
            height: 60px;
            width: auto;
        }
    }

    .hero-title {
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
        font-style: normal;
        font-size: 3vw;
        line-height: 130%;
        letter-spacing: 0.5px;
        text-align: center;
        margin-bottom: 2rem;
        color: white !important;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title-line {
            display: block;
            color: white !important;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .highlight {
            color: #F07D00;
        }
    }


    .cta-button {
        background: #F07D00;
        color: white;
        border: none;
        padding: 0.5rem 2rem;
        border-radius: 50px;
        font-size: 2rem;
        font-weight: 500;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 1.2rem;
        transition: all 0.3s ease;

        &:hover {
            background: #e67300;
            transform: translateY(-2px);
            box-shadow: 0 16px 30px rgba(0, 0, 0, 0.2);
        }

        .arrow-circle {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .hero-image {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .car-image {
            max-width: 100%;
            height: auto;
            max-height: 500px;
            object-fit: contain;
        }
    }
}

// Section des options
.options-section {
    background: white;
    padding: 4rem 0;
    min-height: calc(90vh);

    .container {
        max-width: 1360px;
        margin: 0 auto;
        padding: 0 1rem;
    }

    .options-header {
        text-align: center;
        margin-bottom: 3rem;

        .options-title {
            font-family: 'Poppins', semibold;
            font-weight: 600;
            font-size: 2rem;
            color: #262626;
            margin-bottom: 1.3rem;
            letter-spacing: 0.06em;
            text-transform: uppercase;
        }

        .options-subtitle {
            font-family: 'Poppins', regular;
            font-weight: 400;
            font-size: 1.2rem;
            color: #000;
        }
    }

    .options-cards {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 7rem;
        max-width: 2000px;
        margin: 0 auto;

        .option-card {
            width: 100%;
            min-width: 460px;
            display: flex;
            flex-direction: column;
            background: white;
            border-radius: 16px 16px 24px 24px;
            box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
            overflow: visible;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            position: relative;

            .card-header {
                background: #1e324e;
                padding: 1.5rem 1.5rem;
                text-align: center;
                border-radius: 16px 16px 0 0;

                h3 {
                    font-family: 'Poppins', sans-serif;
                    font-weight: 600;
                    font-size: 1.6rem;
                    letter-spacing: 0.08em;
                    color: #fff;
                    margin: 0;
                    text-transform: uppercase;
                }
            }

            .card-content {
                padding: 2.5rem 2rem 3.5rem;
                text-align: center;
                background-color: #f5f5f5;
                height: 100%;
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                border-radius: 0 0 24px 24px;

                ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;

                    li {
                        font-family: 'Poppins', regular;
                        font-weight: 400;
                        font-size: 1.25rem;
                        line-height: 1.6;
                        color: #000;
                        padding: 0;
                        position: relative;

                        &+li {
                            margin-top: 1.25rem;
                        }

                        strong {
                            font-weight: 500;
                        }
                    }
                }

                .card-button {
                    background: #F07D00;
                    color: white;
                    font-family: 'Poppins', semibold;
                    font-weight: 500;
                    border: none;
                    padding: 0.5rem 2rem;
                    border-radius: 9999px;
                    font-size: 1.5rem;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 0.9rem;
                    transition: all 0.3s ease;
                    width: 58%;
                    justify-content: center;
                    position: absolute;
                    bottom: -28px;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 10;
                    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);

                    &:hover {
                        background: #e67300;
                        transform: translateX(-50%) translateY(-2px);
                        box-shadow: 0 16px 30px rgba(0, 0, 0, 0.2);
                    }

                    .arrow-circle {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 30px;
                            height: 30px;
                        }
                    }
                }
            }
        }
    }
}

// Responsive design
@media (max-width: 768px) {
    .landing-reprise-depot {
        .hero-section {
            min-height: auto;
            padding-top: 6rem;
        }

        .container {
            margin: 0;
            padding: 0;
        }

        .hero-content {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 0;
        }

        .hero-image {
            display: none;
        }

        .hero-title {
            font-size: 1.8rem;
            display: flex;
            font-family: 'Poppins', medium;
            flex-direction: column;
            align-items: center;
            margin-bottom: 0;
        }

        .hero-title .title-line {
            margin-bottom: 1rem;
        }

        .title-line:last-child {
            display: none;
        }

        .cta-button {
            display: none;
        }
    }

    .options-section {
        padding: 3rem 0 6rem 0;
        min-height: calc(100vh); // Ajuster pour mobile
        position: relative;
        background-image: url('/img/landing-page/Opel.png');
        background-size: 350px auto;
        background-repeat: no-repeat;
        background-position: right 70%;
        background-attachment: local;

        .options-header {
            .options-title {
                font-size: 1.8rem;
            }

            .options-subtitle {
                font-size: 1rem;
            }
        }

        .options-cards {
            grid-template-columns: 1fr;
            gap: 4rem;
        }

        .options-cards {
            padding: 0 0.5rem;
        }

        .options-cards .option-card {
            width: 100%;
            max-width: 350px;
            min-width: auto; // override desktop min-width: 460px
            border-radius: 12px 12px 20px 20px;
            position: relative;
            z-index: 2;
            margin: 0 auto;
            background-color: #f3f3f3;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12), 0 15px 50px rgba(0, 0, 0, 0.15);
        }

        .options-cards .option-card .card-header {
            padding: 1rem 1rem;
            border-radius: 12px 12px 0 0;
        }

        .options-cards .option-card .card-header h3 {
            font-size: 1.25rem;
            letter-spacing: 0.06em;
        }

        .options-cards .option-card .card-content {
            padding: 1.25rem 1rem 2.5rem;
            border-radius: 0 0 20px 20px;
        }

        .options-cards .option-card .card-content ul li {
            font-size: 1.05rem;
            line-height: 1.5;
        }

        .options-cards .option-card .card-content .card-button {
            width: 70%;
            font-size: 1rem;
            padding: 0.2rem 1.2rem;
            bottom: -22px;
        }

        .option-card {
            .card-content {
                padding: 1.5rem;

                .card-button {
                    padding: 0.95rem 1.4rem;
                    font-size: 1.1rem;
                    width: 57%;

                    .arrow-circle {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 30px;
                            height: 30px;
                        }
                    }
                }
            }
        }
    }
}

.bouton-gris-transp {
    a {
        color: #F07D00;

        span {
            white-space: nowrap;
        }
    }
}

.errorImmat {
    display: none;
    color: #ff5151;
    font-size: 1rem;
    margin: 10px 0 0;
}

// Section Pourquoi Ewigo
.why-ewigo-section {
    background: #1e324e;
    padding: 4rem 0;
    color: white;

    .container {
        max-width: 2000px;
        margin: 0 auto;
        padding: 0 1rem;
    }

    .why-ewigo-header {
        text-align: center;
        margin-bottom: 3rem;

        .why-ewigo-title {
            font-family: 'Poppins', semibold;
            font-weight: 600;
            font-size: 2rem;
            color: white;
            margin-bottom: 1rem;
            text-transform: uppercase;
        }

        .why-ewigo-subtitle {
            font-family: 'Poppins', regular;
            font-weight: 300;
            font-size: 1.4rem;
            color: white;
        }
    }

    .benefits-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 3rem;
        margin-bottom: 4rem;
        max-width: 1400px;
        margin-left: auto;
        margin-right: auto;
    }

    .benefits-column {
        display: flex;
        flex-direction: column;
        gap: 4rem;
    }

    .benefit-item {
        display: flex;
        align-items: center;
        gap: 1.25rem;
        padding-block: .1rem;

        .benefit-icon {
            min-width: 3rem;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 2rem;
                height: 2rem;
                filter: brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(16deg) brightness(118%) contrast(119%);
            }
        }

        .benefit-text {
            font-family: 'Poppins', semibold;
            font-weight: 600;
            font-size: 1.2rem;
            color: white;
            line-height: 1.7;
        }
    }

    .why-ewigo-cta {
        text-align: center;

        .cta-button {
            background: #F07D00;
            color: white;
            font-family: 'Poppins', semibold;
            font-weight: 500;
            border: none;
            padding: 0.5rem 2rem;
            border-radius: 50px;
            font-size: 1.5rem;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            gap: 1rem;
            transition: all 0.3s ease;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);

            &:hover {
                background: #e67300;
                transform: translateY(-2px);
                box-shadow: 0 16px 30px rgba(0, 0, 0, 0.2);
            }

            .arrow-circle {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 30px;
                    height: 30px;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .why-ewigo-section {
        padding: 2rem 0;

        .why-ewigo-header {
            .why-ewigo-title {
                font-size: 1.8rem;
            }

            .why-ewigo-subtitle {
                font-size: 1rem;
            }
        }

        .benefits-grid {
            grid-template-columns: 1fr;
            gap: 2rem;
            padding: 0 1rem;
        }

        .benefits-column {
            gap: 1.5rem;
        }

        .benefit-item {
            .benefit-icon {
                font-size: 1.5rem;
                min-width: 2.5rem;
            }

            .benefit-text {
                font-size: 1rem;
            }
        }

        .why-ewigo-cta {
            .cta-button {
                padding: 0.2rem 1.5rem;
                font-size: 1rem;
            }
        }
    }
}

// Section Réseaux sociaux, récompenses et note Google
.social-awards-section {
    background: white;
    padding: 4rem 0;
    height: 85vh;

    .container {
        max-width: 100%;
        margin: 0 auto;
        padding: 0 1rem;
        padding-left: 0;
    }

    .social-awards-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 3rem;
        align-items: center;
        height: 100%;
    }

    .left-content {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .social-media {
        h3 {
            font-family: 'Poppins', sans-serif;
            font-weight: 400;
            font-size: 1.2rem;
            color: #333;
            margin-bottom: 3rem;
            text-align: center;
        }

        .social-icons {
            display: flex;
            gap: 2rem;
            justify-content: center;

            .social-icon {
                width: 110px;
                height: 110px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #1e324e;
                border-radius: 8px;
                border: 2px solid white;

                img {
                    width: 100px;
                    height: 100px;
                }
            }
        }
    }

    .awards-google-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2rem;
    }

    .awards-section {
        .awards-badges {
            display: flex;
            justify-content: center;

            .awards-image {
                max-width: 200px;
                height: auto;
            }
        }
    }

    .google-rating {
        .google-rating-image {
            max-width: 250px;
            height: auto;
        }
    }

    .right-content {
        padding-left: 5rem;
        display: flex;
        flex-direction: column;
        gap: 3rem;
    }

    .car-image-container {
        .final-car-image {
            max-width: 100%;
            height: auto;
            max-height: 600px;
            object-fit: contain;
        }
    }
}

@media (max-width: 768px) {
    .social-awards-section {
        padding: 1rem 0;
        height: auto;

        .social-awards-content {
            grid-template-columns: 1fr;
            gap: 1rem;
            text-align: center;
        }

        .left-content {
            gap: 1rem;
        }

        .right-content {
            padding-left: 0;
            display: flex;
            flex-direction: column-reverse;
        }

        .social-media {
            h3 {
                font-size: 1rem;
                margin-bottom: 0.5rem;
            }

            .social-icons {
                justify-content: center;
                gap: 1rem;
                margin-bottom: 5rem;

                .social-icon {
                    width: 50px;
                    height: 50px;
                    background: #1e324e;
                    border-radius: 6px;
                    border: 2px solid white;

                    img {
                        width: 40px;
                        height: 40px;
                    }
                }
            }
        }

        .awards-google-container {
            flex-direction: row;
            gap: 0.5rem;
            justify-content: center;
            align-items: center;
        }

        .awards-section {
            .awards-badges {
                justify-content: center;

                .awards-image {
                    max-width: 200px;
                }
            }
        }

        .google-rating {
            .google-rating-image {
                max-width: 160px;
            }
        }

        .left-content {
            .car-image-container {
                display: none;
            }
        }

        .right-content {
            .car-image-container .final-car-image {
                max-height: 300px;
            }
        }
    }
}
</style>
